import React from 'react'

export default function Header() {
  return (
    <header>
        <h1>BMI Calculator</h1>
    </header>
  )
}

